import React, { FC } from 'react'
import { useNavigate } from 'react-router-dom'
import { motion } from 'framer-motion'
import { getPageData, useData } from '../../../../app/helper/functions'
import DynamicSVG from '../../../atoms/DynamicSvg/DynamicSvg'
import { ReactComponent as JobPostIcon } from "../../../../app/assets/images/job-post.svg";

interface ReliabilityCareerProps {
    jobs: any
}

const ReliabilityCareer: FC<ReliabilityCareerProps> = ({ jobs }) => {
    const { loading, data, error } = useData();
    const homePageData = getPageData(data, 'HomePageData');
    const navigate = useNavigate()
    const containerVariants = {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: {
                staggerChildren: 0.15
            }
        }
    }

    const cardVariants = {
        hidden: { y: 50, opacity: 0 },
        visible: {
            y: 0,
            opacity: 1,
            transition: {
                type: "spring",
                stiffness: 100,
                damping: 12
            }
        },
        hover: {
            scale: 1.05,
            transition: {
                type: "spring",
                stiffness: 300,
                damping: 15
            }
        }
    }

    return (
        <div>
            <motion.div
                className='flex items-center justify-center w-full'
                initial="hidden"
                animate="visible"
                variants={containerVariants}
            >
                <div className='grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 pt-8 sm:pt-12 md:pt-16 gap-4 sm:gap-6 md:gap-8 '>
                    {jobs.map((job: any, idx: number) => {
                        return (
                            <motion.div
                                key={idx}
                                className='group w-full'
                                variants={cardVariants}
                                whileHover="hover"
                            >
                                <div className={`group-hover:bg-yellow group-hover:text-black bg-darkGreyPrimary text-white border-2 border-[#323232] rounded-2xl py-5 px-3 sm:py-6 sm:px-4 flex items-center justify-center flex-col gap-2 h-full`}>
                                    <motion.div
                                        className='w-[25%] sm:w-[30%]'
                                        whileHover={{ rotate: [0, -5, 5, -5, 0] }}
                                        transition={{ duration: 0.5 }}
                                    >
                                        <div className="h-20 w-20 mx-auto">
                                            <DynamicSVG
                                                color="#fff"
                                                size="w-full h-full object-cover transition-transform duration-300 hover:scale-105"
                                            >
                                                <JobPostIcon />
                                            </DynamicSVG>
                                        </div>
                                    </motion.div>
                                    <div className='font-bold text-lg sm:text-xl text-center'>{job.title}</div>
                                    <div className='flex flex-col items-center'>
                                        <div>Experience : {job.experience}</div>
                                        <div>Vacancy : {job.vacancy}</div>
                                        <div>{job.location}</div>
                                    </div>
                                    <motion.div
                                        className={`group-hover:border-black border-yellow border cursor-pointer px-4 sm:px-6 py-1.5 sm:py-2 rounded-lg font-bold uppercase mt-2 text-sm sm:text-base`}
                                        onClick={() => { navigate('/apply', {state: job.title})}}
                                        whileTap={{ scale: 0.95 }}
                                    >
                                        Apply Now
                                    </motion.div>
                                    <span>Or</span>
                                    <motion.div
                                        className={`cursor-pointer px-4 sm:px-6 py-1.5 sm:py-2 rounded-lg text-sm sm:text-base text-center flex flex-col gap-1`}
                                        whileTap={{ scale: 0.95 }}
                                        onClick={() => window.open(`tel:${homePageData.company_number}`, '_self')}
                                    >
                                        <span>Contact At</span>
                                        <span className='font-semibold'>{homePageData.company_number}</span>
                                       
                                    </motion.div>
                                </div>
                            </motion.div>
                        )
                    })}
                </div>
            </motion.div>
        </div>
    )
}

export default ReliabilityCareer
